import React, { useEffect, useState } from "react";
import { Card, Table, TableBody, TableCell, TableContainer, TablePagination, TableRow, Box, MenuItem, Chip } from "@material-ui/core";
import { Button, IconButton, InputBase, Paper, TextField, Select, FormControl, InputLabel, Dialog, DialogActions, DialogContent, DialogTitle, useMediaQuery, Typography } from "@mui/material";
import { styled } from '@mui/material/styles';
import { useQuery } from 'react-query';
import { FOOD_ITEMS } from "src/api/axios";
import UserListHead from "src/components/user/UserListHead";
import useAxiosPrivate from "src/hooks/useAxiosPrivate";
import Stack from '@mui/material/Stack';
import { useSnackbar } from "notistack";
import EditPenIcon from "src/svgComponents/EditPenIcon";
import BinIcon from "src/svgComponents/BinIcon";
import CloseIcon from '@mui/icons-material/Close';
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { useTheme } from '@mui/material/styles';
import { useMutation } from "react-query";
import FormHelperText from "@mui/material/FormHelperText";
import SearchIcon from "src/svgComponents/SearchIcon";
import LoadingScreen from "src/components/LoadingScreen";
import useStore from 'src/contexts/AuthProvider'
import ShowImage from "../common/ShowImage";
import moment from "moment";
import AppTooltip from "src/components/common/AppTooltip";
import DefaultImage from "../../assets/images/food_default_image.png";
import { LoadingButton } from '@mui/lab';
import ButtonText from "src/components/common/ButtonText";

const _ = require('lodash');

const FoodItems = () => {
   const [tableData, setTableData] = useState([]);
   const [page, setPage] = useState(0);
   const [rowsPerPage, setRowsPerPage] = useState(10);
   const [order, setOrder] = useState('desc');
   const [orderBy, setOrderBy] = useState('createdAt');
   const axiosPrivate = useAxiosPrivate();
   const [openModal, setOpenModal] = useState(false);
   const [foodCategory, setFoodCategory] = useState();
   const [profilePic, setProfilePic] = useState("");
   const [imageName, setImageName] = useState();
   const [showImage, setShowImage] = useState();
   const [foodMenuData, setFoodMenuData] = useState();
   const [modelTitle, setmodelTitle] = useState("");
   const [filterName, setFilterName] = useState('');
   const [food_category_id, setFoodCategoryId] = useState('');
   const [food_menu_id, setFoodMenuId] = useState('');
   const [disable, setDisable] = useState(false);
   const [Id, setId] = useState("");
   const { enqueueSnackbar } = useSnackbar();
   const [deleteId, setdeleteId] = useState("");
   const [open, setOpen] = useState(false);
   const theme = useTheme();
   const [loading, setLoding] = useState(true);
   const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
   const permissionsData = useStore(state => state.permissions);
   const [uploadedImage, setUploadedImage] = useState();
   const [flag, setFlag] = useState();
   const [buttonLoading, setButtonLoding] = useState(false);

   const StyledTableRow = styled(TableRow)(({ theme }) => ({
      '&:nth-of-type(odd)': {
         backgroundColor: '#ffffff',
      },
      '&:nth-of-type(even)': {
         background: "linear-gradient(0deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)), #F4F5F7",
      },
      // hide last border
      '& td, & th': {
         border: 0,
      },
   }));

   const TABLE_HEAD = [
      { id: 'name', label: 'Food Name', alignRight: false },
      { id: 'image', label: 'Food Photo', alignRight: false },
      { id: 'description', label: 'Description', alignRight: false },
      { id: 'price', label: 'MRP', alignRight: false },
      { id: 'discount', label: 'Discount', alignRight: false },
      { id: 'offerPrice', label: 'Offer Price', alignRight: false },
      { id: 'category name', label: 'From Category', alignRight: false },
      { id: 'menu name', label: 'From Menu', alignRight: false },
      { id: 'created', label: 'Dated On', alignRight: false },
      { id: 'status', label: 'Status', alignRight: false },
      { id: 'action', label: 'Action', alignRight: false },
   ];

   async function getFoodItems(page, filterName) {
      const response = await axiosPrivate.get(FOOD_ITEMS.getFood, { params: { page: page + 1, search: filterName, limit: rowsPerPage } })
      return response.data[0];
   }

   const { data: foodItemList, refetch } = useQuery(['foodItemList', page, filterName], () => getFoodItems(page, filterName), { keepPreviousData: true, })

   useEffect(() => {
      if (foodItemList) {
         setTableData(foodItemList.data);
         setRowsPerPage(foodItemList?.metadata.length != 0 ? foodItemList?.metadata[0].limit : 10);
      }
      if (foodItemList?.metadata.length != 0 && foodItemList?.metadata[0].hasMoreData == true) {
         getFoodItems(page + 1);
      }
      setTimeout(() => {
         setLoding(false);
      }, 1000)
   }, [foodItemList])

   const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
      setTimeout(() => {
         refetch();
      }, 500);
   };
   const handleChangePage = (event, newPage) => {
      setPage(newPage);
   };
   const handleFilterByName = (event) => {
      setFilterName(event.target.value.trim());
      setPage(0);
      getFoodItems(page, filterName)
      refetch();
   };
   async function getFoodCategory() {
      const response = await axiosPrivate.get(FOOD_ITEMS.getFoodCategoryList, { params: { page: 1 } })
      return response.data;
   }
   const { data: foodCategorys } = useQuery(['foodCategorys'], () => getFoodCategory(), { keepPreviousData: true, })
   useEffect(() => {
      if (foodCategorys !== undefined) {
         setFoodCategory(foodCategorys)
      }
   }, [foodCategorys])

   async function getFoodMenuData() {
      const response = await axiosPrivate.get(FOOD_ITEMS.getFoodMenuData)
      return response.data;
   }
   const { data: FoodMenuList } = useQuery(['FoodMenuList'], () => getFoodMenuData(), { keepPreviousData: true, })

   useEffect(() => {
      if (FoodMenuList !== undefined) {
         setFoodMenuData(FoodMenuList)
      }
   }, [FoodMenuList])

   const completedSchema = Yup.object().shape({
      name: Yup.string()
         .min(2, "name can set of between 2 and 50 characters!")
         .max(50, "name can set of between 2 and 50 characters!")
         .required("name is required"),
      price: Yup.number()
         .required('price is required')
         .min(1, "price must be greater than 1"),
      // .max(99999, "price must be less than 99999"),
      offerPrice: Yup.number()
         .required('offer price is required')
         .min(1, "offer price must be greater than 1"),
      // .max(99999, "offer price must be less than 99999"),
      description: Yup.string().required('description is required'),
      food_category_id: Yup.string().required('from category is required'),
      food_menu_id: Yup.string().required('from menu is required'),
   });

   const handleUploadImage = async () => {
      const formData = new FormData();
      formData.append('image', uploadedImage)
      const imageData = await axiosPrivate
         .post(FOOD_ITEMS.uploadImage, formData)
         .catch((e) => {
            setButtonLoding(false);
            enqueueSnackbar(e?.response?.data?.message, {
               variant: "error",
               anchorOrigin: { vertical: "top", horizontal: "right" },
               autoHideDuration: 2000,
            });
         });
      setImageName(imageData?.data?.file_name)
      setFieldValue("image", imageData?.data?.file_name)
      return imageData?.data?.file_name;
   }

   const formik = useFormik({
      initialValues: {
         food_category_id: "",
         food_menu_id: "",
         name: "",
         price: "",
         discount: "",
         offerPrice: "",
         description: "",
         image: ""
      },
      validationSchema: completedSchema,
      onSubmit: async (values, { resetForm, setFieldError, setSubmitting }) => {
         if (values.food_category_id === '') {
            setFieldError({ food_category_id: 'Please select from category' });
            return;
         } else if (values.food_menu_id === '') {
            setFieldError({ food_menu_id: 'Please select from category' });
            return;
         } else {
            let image_name = '';
            if (!imageName) {
               if (flag === 'asd') {
                  image_name = await handleUploadImage();
               }
            } else {
               image_name = imageName
            }
            if (image_name) {
               setButtonLoding(true)
            }
            const informationObj = {
               name: values.name.trim(),
               price: values.price,
               discount: values.discount,
               offerPrice: values.offerPrice,
               description: values.description,
               image: image_name
            };
            if (food_category_id) {
               informationObj.food_category_id = food_category_id;
            }
            if (food_menu_id) {
               informationObj.food_menu_id = food_menu_id;
            }
            if (Id == "") {
               await foodAdd(informationObj);
            } else {
               await foodItemUpdate(informationObj);
            }
            resetForm();
            setSubmitting(false);
         }
      },
   });

   const { mutateAsync: foodAdd } = useMutation(
      async (data) => {
         return await axiosPrivate.post(FOOD_ITEMS.addFood, data)
      },
      {
         onSuccess: ({ data }) => {
            setButtonLoding(false);
            enqueueSnackbar("Item add successfully ", {
               variant: "success",
               anchorOrigin: { vertical: "top", horizontal: "right" },
               autoHideDuration: 2000,
            });
            handleCloseModal();
            refetch();
         },
         onError: (error) => {
            setButtonLoding(false)
            const errorData = error.response.data.errors;
            if (error.response?.data?.message) {
               enqueueSnackbar(error.response?.data?.message, {
                  variant: "error",
                  anchorOrigin: { vertical: "top", horizontal: "right" },
                  autoHideDuration: 2000,
               });
            }
            Object.keys(errorData).forEach((key) => {
               if (key === "name") {
                  setFieldError("name", errorData[key]);
               } else if (key === "food_category_id") {
                  setFieldError(key, errorData[key]);
               }
               else if (key === "food_menu_id") {
                  setFieldError(key, errorData[key]);
               }
               else if (key === "price") {
                  setFieldError(key, errorData[key]);
               }
               else if (key === "discount") {
                  setFieldError(key, errorData[key]);
               }
               else if (key === "offerPrice") {
                  setFieldError(key, errorData[key]);
               }
               else if (key === "description") {
                  setFieldError(key, errorData[key]);
               }
               else if (key === "image") {
                  setFieldError(key, errorData[key]);
               }
               else {
                  setFieldError(key, errorData[key]);
               }
            });
         },
      }
   );

   const { mutateAsync: foodItemUpdate } = useMutation(
      async (data) => {
         return await axiosPrivate.put(FOOD_ITEMS.editFood + Id, data)
      },
      {
         onSuccess: ({ data }) => {
            setButtonLoding(false);
            refetch();
            enqueueSnackbar("Item update successfully ", {
               variant: "success",
               anchorOrigin: { vertical: "top", horizontal: "right" },
               autoHideDuration: 2000,
            });
            handleCloseModal();
         },
         onError: (error) => {
            setButtonLoding(false);
            const errorData = error.response.data.errors;
            if (error.response?.data?.message) {
               enqueueSnackbar(error.response?.data?.message, {
                  variant: "error",
                  anchorOrigin: { vertical: "top", horizontal: "right" },
                  autoHideDuration: 2000,
               });
            }
            Object.keys(errorData).forEach((key) => {
               if (key === "name") {
                  setFieldError("name", errorData[key]);
               } else {
                  setFieldError(key, errorData[key]);
               }
            });
         },
      }
   );

   function descendingComparator(a, b, orderBy) {
      if (b[orderBy] < a[orderBy]) {
         return -1;
      }
      if (b[orderBy] > a[orderBy]) {
         return 1;
      }
      return 0;
   }

   function getComparator(order, orderBy) {
      return order === 'desc'
         ? (a, b) => descendingComparator(a, b, orderBy)
         : (a, b) => -descendingComparator(a, b, orderBy);
   }
   function applySortFilter(array, comparator) {
      const stabilizedThis = array.map((el, index) => [el, index]);
      stabilizedThis.sort((a, b) => {
         const order = comparator(a[0], b[0]);
         if (order !== 0) return order;
         return a[1] - b[1];
      });

      return stabilizedThis.map((el) => el[0]);
   }

   const handleRequestSort = (event, property) => {
      const isAsc = orderBy === property && order === 'asc';
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(property);
   };

   // const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - categoryList?.metadata[0].total) : 0;

   const filteredUsers = applySortFilter(tableData, getComparator(order, orderBy));

   const handleClose = () => {
      setOpen(false);
      setShowImage('');
   };

   const deleteFoodItem = async () => {
      const response = await axiosPrivate.delete(FOOD_ITEMS.deleteFood + deleteId)
      if (response.status == 200) {
         enqueueSnackbar("Item deleted successfully", {
            variant: "success",
            anchorOrigin: { vertical: "top", horizontal: "right" },
            autoHideDuration: 2000,
         });
      } else {
         enqueueSnackbar("something went wrong", {
            variant: "error",
            anchorOrigin: { vertical: "top", horizontal: "right" },
            autoHideDuration: 2000,
         });
      }
      refetch();
      handleClose();
   };

   const handleOpenModalAdd = () => {
      setFieldValue('name', "")
      setFieldValue('price', "")
      setFieldValue('description', "")
      setFieldValue('food_category_id', "")
      setFieldValue('food_menu_id', "")
      setFieldValue('discount', "")
      setFieldValue('offerPrice', "")
      setFoodCategoryId('')
      setFoodMenuId('')
      setShowImage('');
      setProfilePic('');
      setImageName('');
      setFlag('')
      setId('')
      setmodelTitle('Food Item Add')
      setDisable(false);
      setOpenModal(true);
   };

   const handleOpenModalUpdate = (row) => {
      if (row.discount === undefined) {
         setFieldValue('offerPrice', row.price)
      } else {
         setFieldValue('offerPrice', row.offerPrice)
      }
      setProfilePic('')
      setFoodCategoryId(row?.food_category_data?._id)
      setFoodMenuId(row?.food_menu_data?._id)
      setFieldValue("food_category_id", row?.food_category_data?._id)
      setFieldValue("food_menu_id", row?.food_menu_data?._id)
      setFieldValue('name', row.name)
      setFieldValue('price', row.price)
      setFieldValue('discount', row.discount)
      setFieldValue('description', row.description)
      setFieldValue('image', row.image)
      setImageName(row.image)
      setShowImage(row.image)
      setId(row._id)
      setmodelTitle('Food Item Update')
      setDisable(true);
      setOpenModal(true);
   };

   const handleClickOpen = (categoryId, categoryType) => {
      setdeleteId(categoryId);
      setOpen(true);
   };

   const handleCloseModal = () => {
      setOpenModal(false);
      resetForm();
   };

   const handleProfilePicOnChange = async (ev) => {
      if (ev.type.includes("image")) {
         setUploadedImage(ev);
         let userImgSrc = URL.createObjectURL(ev);
         setProfilePic(userImgSrc);
         setImageName('')
      } else {
         enqueueSnackbar("Please select only jpeg, jpg, png, webp file", {
            variant: "error",
            anchorOrigin: { vertical: "top", horizontal: "right" },
            autoHideDuration: 2000,
         });
      }
   };

   const { errors, touched, setFieldValue, handleSubmit, setFieldError, getFieldProps, setFieldTouched, resetForm } = formik;

   const handleFoodCategoryOnChange = (event) => {
      setFoodCategoryId(event.target.value);
   };

   const handleFoodMenuOnChange = (event) => {
      setFoodMenuId(event.target.value);
   };

   const changeStatus = async (id) => {
      const response = await axiosPrivate.put(FOOD_ITEMS.changeFoodItemStatus + id)
      if (response?.data?.message) {
         enqueueSnackbar(response?.data?.message, {
            variant: "success",
            anchorOrigin: { vertical: "top", horizontal: "right" },
            autoHideDuration: 2000,
         });
      }
      refetch()
   }

   const removeImage = () => {
      setProfilePic('');
      setImageName('');
      setShowImage('');
   }
   const setDiscount = (e) => {
      let price = getFieldProps("price");
      let discount = e.target.value;
      setFieldValue('discount', discount)
      let discountInRs = price.value * discount / 100;
      let offerPrice = price.value - discountInRs;
      setFieldValue('offerPrice', offerPrice)
   }

   const setPrice = (e) => {
      let discount = getFieldProps("discount");
      let price = e.target.value;
      setFieldValue('price', price)
      let discountInRs = price * discount.value / 100;
      let offerPrice = price - discountInRs;
      if (discount.value) {
         setFieldValue('offerPrice', offerPrice)
      } else {
         setFieldValue('offerPrice', price)
      }
   }

   return (
      <>
         <LoadingScreen loading={loading} />
         <div className="dashboard_header mb-4">
            <h4 className="app_text_20_semibold mb-0 d-flex align-items-center">Food Dish Items</h4>
            <Box className="d-flex align-items-center">
               <Paper component="form" className='dashboard_searchbox' sx={{ minWidth: '380px' }}>
                  <IconButton>
                     <SearchIcon />
                  </IconButton>
                  <InputBase
                     fullWidth
                     sx={{ flex: 1 }}
                     placeholder="search food..."
                     onChange={(e) => handleFilterByName(e)}
                     onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                  />
               </Paper>
               <Stack direction={"row"} className="d-flex align-items-center ms-lg-4 ms-2" spacing={2}>
                  {permissionsData?.food_items?.substring(1, 2) == "1" ?
                     <AppTooltip title="Add Items" placement="bottom">
                        <ButtonText text={'Add Item'} onClickBtn={() => handleOpenModalAdd()} />
                     </AppTooltip> : ""}
               </Stack>
            </Box>
         </div>
         <Card>
            <TableContainer>
               <Table>
                  <UserListHead
                     headLabel={TABLE_HEAD}
                     rowCount={foodItemList?.data?.length}
                     onRequestSort={handleRequestSort}
                  />
                  {filteredUsers?.length > 0 ?
                     <TableBody>
                        {filteredUsers.map((row) => {
                           return (
                              <StyledTableRow key={row._id}>
                                 <TableCell component="th" scope="row">
                                    <span className="d-flex text-nowrap">{row.name}</span>
                                 </TableCell>
                                 <TableCell component="th" scope="row">
                                    <img src={row.image ? process.env.REACT_APP_PROFILE_URL + 'foodItem/' + row.image : DefaultImage} height="53px" width="73px" alt="profile" />
                                 </TableCell>
                                 <TableCell align="left" style={{ width: '340px', wordBreak: 'break-word' }} component="th"> {row?.description?.substring(0, 38) + (row?.description.length >= 38 ? ' ....' : '')}</TableCell>
                                 <TableCell align="left"> £{row.price?.toFixed(2) ?? '0.00'}</TableCell>
                                 <TableCell align="left"> {row.discount ? row.discount + '%' : '-'}</TableCell>
                                 <TableCell align="left"> £{row.offerPrice?.toFixed(2) ?? '0.00'}</TableCell>
                                 <TableCell align="left"> {row.food_category_data && row.food_category_data?.name}</TableCell>
                                 <TableCell align="left"> {row.food_menu_data && row.food_menu_data?.name}</TableCell>
                                 <TableCell align="left" style={{ width: '300px' }}><span className="d-flex text-nowrap">{moment(row.createdAt).format("DD MMM YYYY h:mm A")}</span></TableCell>
                                 <TableCell>
                                    <Stack direction="row" spacing={3}>
                                       {
                                          row.status == 1 ? <Chip variant="contained" label="Enable" className="app_status_chip accepted" onClick={permissionsData?.food_items?.substring(2, 3) == "1" ? () => changeStatus(row._id) : ""} /> : <Chip variant="contained" className="app_status_chip invalid" label="Disable" onClick={() => changeStatus(row._id)} />
                                       }
                                    </Stack>
                                 </TableCell>
                                 <TableCell>
                                    <Stack direction="row" spacing={3}>
                                       {permissionsData?.food_items?.substring(3, 4) == "1" ?
                                          <AppTooltip title="Edit Item" placement="bottom">
                                             <Button sx={{ "&:hover": { bgcolor: "transparent" } }} onClick={() => handleOpenModalUpdate(row)} variant="text" className="user_list_row_btn"><EditPenIcon /></Button>
                                          </AppTooltip> : ""}
                                       {permissionsData?.food_items?.substring(2, 3) == "1" ?
                                          <AppTooltip title="Delete Item" placement="bottom">
                                             <Button variant="text" className="user_list_row_btn" onClick={() => handleClickOpen(row._id, "main")} ><BinIcon /></Button>
                                          </AppTooltip> : ""}
                                    </Stack>
                                 </TableCell>
                              </StyledTableRow>
                           )
                        })}
                     </TableBody>
                     :
                     <TableBody>
                        <TableRow>
                           <TableCell align="center" colSpan={11} sx={{ py: 5 }}>
                              <span className="app_text_16_semibold">No Data Found</span>
                           </TableCell>
                        </TableRow>
                     </TableBody>}

               </Table>
            </TableContainer>
            <TablePagination
               component="div"
               rowsPerPageOptions={[10, 20, 50, 100]}
               count={foodItemList?.metadata.length != 0 ? foodItemList?.metadata[0].total : 0}
               rowsPerPage={rowsPerPage}
               page={page}
               onPageChange={handleChangePage}
               onRowsPerPageChange={handleChangeRowsPerPage}
            />
         </Card>
         <Dialog
            open={openModal}
            onClose={handleCloseModal}
            aria-labelledby="child-modal-title"
            aria-describedby="child-modal-description"
         >
            <DialogTitle>
               <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <h4>{modelTitle}</h4>
                  <Button className="dashboard_light_bg_icon_btn" onClick={handleCloseModal} aria-label="delete">
                     <CloseIcon style={{ color: '#fff' }} />
                  </Button>
               </Box>
            </DialogTitle>
            <DialogContent className="custom_form_mui pt-2">
               <FormikProvider value={formik}>
                  <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                     <div className="row">
                        <div className="col-lg-6">
                           <FormControl fullWidth className="mb-3">
                              <InputLabel id="demo-simple-select-label">From Category</InputLabel>
                              <Select
                                 labelId="demo-simple-select-label"
                                 id="food_category_id"
                                 label="From Category"
                                 value={food_category_id}
                                 name="food_category_id"
                                 onChange={(e) => {
                                    handleFoodCategoryOnChange(e);
                                    setFieldTouched("food_category_id", true)
                                    setFieldValue("food_category_id", e.target.value)
                                 }}
                              >
                                 {
                                    foodCategory?.map((result, i) => {
                                       return (
                                          <MenuItem value={result._id} key={i} >
                                             {result.name}
                                          </MenuItem>
                                       )
                                    })
                                 }
                              </Select>
                              {errors.food_category_id && touched.food_category_id && <Typography color="error">{errors.food_category_id}</Typography>}
                              {/* <FormHelperText error>
                                       {errors.food_category_id}
                                    </FormHelperText> */}
                           </FormControl>
                        </div>
                        <div className="col-lg-6">
                           <FormControl fullWidth className="mb-3">
                              <InputLabel id="demo-simple-select-label"
                              >From Menu</InputLabel>
                              <Select
                                 labelId="demo-simple-select-label"
                                 id="food_menu_id"
                                 label="From Menu"
                                 name="food_menu_id"
                                 value={food_menu_id}
                                 onChange={(e) => {
                                    handleFoodMenuOnChange(e);
                                    setFieldTouched("food_menu_id", true)
                                    setFieldValue("food_menu_id", e.target.value)
                                 }}
                              >
                                 {
                                    foodMenuData?.map((result, i) => {
                                       return (
                                          <MenuItem value={result._id} key={i} >
                                             {result.name}
                                          </MenuItem>
                                       )
                                    })
                                 }
                              </Select>
                              {errors.food_menu_id && touched.food_menu_id && <Typography color="error">{errors.food_menu_id}</Typography>}
                           </FormControl>
                        </div>
                        <div className="col-lg-6">
                           <div className="form-group mb-3">
                              <TextField label='Food Name' name='name' autoComplete='off' fullWidth variant='outlined'
                                 {...getFieldProps("name")}
                              />
                              {errors.name && touched.name && <Typography color="error">{errors.name}</Typography>}
                           </div>
                        </div>
                        <div className="col-lg-6">
                           <div className="form-group mb-4">
                              <TextField label='Price' name='price' type='number' autoComplete='off' fullWidth variant='outlined'
                                 {...getFieldProps("price")} onChange={(e) => setPrice(e)}
                              />
                              {errors.price && touched.price && <Typography color="error">{errors.price}</Typography>}
                           </div>
                        </div>
                        <div className="col-lg-6">
                           <div className="form-group mb-4">
                              <TextField label='Discount(%)' name='discount' type='number' autoComplete='off' fullWidth variant='outlined'
                                 {...getFieldProps("discount")} onChange={(e) => setDiscount(e)}
                              />
                              {errors.discount && touched.discount && <Typography color="error">{errors.discount}</Typography>}
                           </div>
                        </div>
                        <div className="col-lg-6">
                           <div className="form-group mb-4">
                              <TextField label='Offer Price' name='offerPrice' type='number' autoComplete='off' fullWidth variant='outlined'
                                 {...getFieldProps("offerPrice")} disabled
                              />
                              {errors.offerPrice && touched.offerPrice && <Typography color="error">{errors.offerPrice}</Typography>}
                           </div>
                        </div>
                        <div className="col">
                           <div className="form-group mb-4">
                              <TextField sx={{ "& .MuiInputBase-input.MuiOutlinedInput-input": { minHeight: '3.5rem' } }} label='Description' multiline name='description' autoComplete='off' fullWidth
                                 {...getFieldProps("description")}
                              />
                              {errors.description && touched.description && <Typography color="error">{errors.description}</Typography>}
                           </div>
                        </div>
                        {/* <div className="col-lg-6">
                              <div className="form-group mb-4">
                                 <TextField label='Order Number' name='order_number' type="number" autoComplete='off' fullWidth variant='outlined'
                                    {...getFieldProps("order_number")}
                                 />
                                 {errors.order_number && touched.order_number && <Typography color="error">{errors.order_number}</Typography>}
                              </div>
                           </div> */}
                     </div>
                     <div className="col-lg-6">
                        <ShowImage modalId={Id} profilePic={profilePic} showImage={showImage} folderName="foodItem/" onRemoveFunc={() => { removeImage() }} />
                        <Button
                           className="my-4 text-white app_bg_primary app_text_14_500 p-2"
                           variant="contained"
                           component="label"
                           style={{ "borderRadius": 5 }}
                        >
                           {Id ? 'Change image' : 'Select Image'}
                           <input
                              hidden
                              accept="image/*"
                              onChange={(event) => {
                                 const files = event.target.files[0];
                                 if (files !== undefined) {
                                    setFlag('asd')
                                    handleProfilePicOnChange(files);
                                 }
                              }}
                              type="file"
                           />
                        </Button>
                        <FormHelperText error>
                           {errors.image}
                        </FormHelperText>
                     </div>
                     <div className="col">
                        <div className="col-md-8 m-auto">
                           <LoadingButton
                              type='submit'
                              fullWidth
                              className="my-3 text-lowercase text-white app_bg_primary app_text_16_semibold app_btn_lg"
                              loading={buttonLoading}
                              loadingPosition="end"
                              variant="contained"
                           >
                              submit
                           </LoadingButton>
                        </div>
                     </div>
                  </Form>
               </FormikProvider>
            </DialogContent>
         </Dialog>
         <Dialog
            fullScreen={fullScreen}
            open={open}
            onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
         >
            <DialogTitle id="responsive-dialog-title" className='m-auto'>
               {"Are you sure you want to delete?"}
            </DialogTitle>
            <DialogContent>
            </DialogContent>
            <DialogActions className='m-auto'>
               <Button className="theme_button_view" variant="contained" autoFocus onClick={handleClose}>
                  cancel
               </Button>
               <Button className="theme_button" variant="contained" onClick={() => deleteFoodItem()} autoFocus>
                  delete
               </Button>
            </DialogActions>
         </Dialog>
      </>
   )
}

export default FoodItems
